import { Controller } from '@hotwired/stimulus';

let messengerLoad = null;

/**
 * Boots the Messenger and loads Intercom's widget script, once per page. Calls
 * made before the script runs wait in the same queue Intercom's own snippet
 * uses, and the widget replays them on load. A failed load clears the queue so
 * the Care links see no Intercom and stay email.
 *
 * @param {string} url the widget script
 * @param {Object} settings boot settings, from intercom_messenger_settings
 * @returns {Promise<void>} resolves once the widget script has run
 */
const loadMessenger = (url, settings) => {
  if (messengerLoad) return messengerLoad;

  messengerLoad = new Promise((resolve, reject) => {
    const queue = function () {
      queue.q.push(arguments);
    };
    queue.q = [];
    window.Intercom = queue;
    window.Intercom('boot', settings);

    const script = document.createElement('script');
    script.async = true;
    script.src = url;
    script.onload = () => resolve();
    script.onerror = () => {
      messengerLoad = null;
      script.remove();
      if (window.Intercom === queue) delete window.Intercom;
      reject(new Error('Intercom Messenger failed to load'));
    };
    document.head.appendChild(script);
  });

  return messengerLoad;
};

/**
 * Mounts the Intercom Messenger on connect, so unread replies show and the
 * Care links can switch to chat. Only signed-in account pages and the cancel
 * flow render it.
 */
export default class extends Controller {
  static values = { settings: Object, widgetUrl: String };

  connect() {
    loadMessenger(this.widgetUrlValue, this.settingsValue).catch(() => {});
  }
}
